// extracted by mini-css-extract-plugin
export default {"title":"NationalSchoolGames_title__uMZTc","game_sgfi":"NationalSchoolGames_game_sgfi__vi6fl","game_card":"NationalSchoolGames_game_card__vSONp"};